import React, { useState } from "react";
import { AppBar, Toolbar, Tooltip, Button, useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { styled } from "@mui/system";
import { DrawerModal } from "./DrawerModal";
import Logo from "./Logo";
import Search from "./Search";
import AccountActions from "./AccountActions";
import CategoryMenu from "./CategoryMenu";
import { useLocation } from "react-router-dom";

const CategoriesButton = styled(Button)({
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  minWidth: "40px",
  padding: 0,
  margin: "0 4px",
  color: "#000000de",
  "&:hover": {
    backgroundColor: "#dedede",
  },
  "@media (max-width: 600px)": {
    marginLeft: "-10px",
  },
});

const MenuIconStyled = styled(MenuIcon)({ fontSize: 30 });

const StyledToolbar = styled(Toolbar)({
  // height: "60px",
  // position: "fixed",
  // backgroundColor: "#fff",
  // width: "100%",
  // top: 0,
  // zIndex: 1000,
});

interface NavBarProps {
  onSearch: (query: string) => void;
  onLogin: () => void;
  onSell: () => void;
  userName: string;
}

const NavBar: React.FC<NavBarProps> = ({
  onSearch,
  onLogin,
  onSell,
  userName,
}) => {
  const location = useLocation();

  const isMobileScreen = useMediaQuery("(max-width:600px)");
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const renderAccountActions = () =>
    !isMobileScreen && <AccountActions onLogin={onLogin} onSell={onSell} />;

  React.useEffect(() => {
    setDrawerOpen(false);
  }, [location]);

  return (
    <AppBar
      position="fixed"
      color="default"
      style={{
        background: "#fff",
        boxShadow: "none",
        margin: 0,
        padding: 0,
        height: "60px",
        top: 0,
        zIndex: 1000,
      }}
    >
      <StyledToolbar>
        <Logo />
        <Tooltip title="Categories" arrow placement="top">
          <CategoriesButton onClick={handleDrawerOpen}>
            <MenuIconStyled />
          </CategoriesButton>
        </Tooltip>
        <Search onSearch={onSearch} />
        {renderAccountActions()}
      </StyledToolbar>

      <DrawerModal
        isOpen={isDrawerOpen}
        onClose={handleDrawerClose}
        anchor="bottom"
        onOpen={() => {}}
      >
        <CategoryMenu />
      </DrawerModal>
    </AppBar>
  );
};

export default NavBar;
